import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"
import SourceStatusButton from "../../SourceStatusButton"

const SourceViewItemDetails = ({
    name,
    url,
    description,
    active,
    favicon,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={30}
                maxLineLength={60}
            >
                <p>{name || "No name"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-article" />URL
            </h3>
            <ContentLoaderLines isFetching={isFetching}>
                <p>
                    {url ? (
                        <a href={url} target="_blank" rel="noopener noreferrer">
                            {url}
                        </a>
                    ) : (
                        "No URL"
                    )}
                </p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-headline" />Description
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>{description || "No description"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-article" />Status
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1} tagLength={20}>
                <SourceStatusButton active={active} />
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-heroimg" />Logo
            </h3>
            <BackgroundImage
                imageUrl={favicon}
                classList={["item-background-image"]}
            />
        </div>
    </div>
)

export default SourceViewItemDetails
